import { useCallback } from 'react';
import useMountedState from './useMountedState';

var usePromise = function usePromise() {
  var isMounted = useMountedState();
  return useCallback(function (promise) {
    return new Promise(function (resolve, reject) {
      var onValue = function onValue(value) {
        isMounted() && resolve(value);
      };

      var onError = function onError(error) {
        isMounted() && reject(error);
      };

      promise.then(onValue, onError);
    });
  }, []);
};

export default usePromise;